import React, {useState} from 'react'
import {FormHelperText} from '@material-ui/core'
import {PinCodeContainer, PinCodeInputUnit} from './style'

const PinCodeInput = ({
  length,
  onComplete,
  obfuscation,
  autoFocusFirst,
  error,
  helperText,
  ...props
}) => {
  const pinInputRefs = []
  const [code, setCode] = useState(new Array(length).fill(''))
  const [editing, setEditing] = useState(null);
  const [reset, setReset] = useState(false);

  const focus = id => {
    if (pinInputRefs[id]) {
      pinInputRefs[id].focus()
    }
  };
  const blur = id => {
    if (pinInputRefs[id]) {
      pinInputRefs[id].blur()
    }
  };
  const setFocus = id => {
    let newCode = code.slice()
    for (let i = 0; i < newCode.length; i++) {
      if (i >= id) {
        newCode[i] = ''
      }
    }
    setCode(newCode)
    setEditing(id)
  };
  const handleEdit = (value, id) => {
    let newCode = code.slice()
    // Detecting if the entire code has been pasted or autofilled into the first field.
    const pasting = value.length > 1 && id === 0
    if (pasting) {
      const filledCode = value.split('')
      // Need to update state so UI updates.
      setCode(
        newCode.map((digit, i) => (filledCode[i] ? filledCode[i] : digit)),
      );
      setEditing(filledCode.length >= length ? length - 1 : filledCode.length)
      setReset(false)
      focus(editing)
    } else {
      newCode[id] = value[0]
    }
    // User filling the last pin ?
    const lastPin = id === length - 1 || (pasting && value.length === length)
    if (lastPin) {
      // focus(0)
      setEditing(null)
      setCode(newCode)
      blur(id);
      onComplete(newCode.join(''))
      return;
    }
    focus(editing + 1)
    setCode(newCode)
    setEditing(editing + 1)
    setReset(false)
  };
  const onKeyPress = (event) => {
    if (event.key === 'Backspace') {
      const toFocus = editing > 0 ? editing - 1 : 0
      focus(toFocus)
    }
  };
  const onKeyDown = (event) => {
    if (event.key === 'Backspace') {
      const toFocus = editing > 0 ? editing - 1 : 0
      focus(toFocus)
    }
  };
  const pins = []

  for (let index = 0; index < length; index++) {
    const id = index
    const value = code[id] ? (obfuscation ? '•' : code[id].toString()) : ''
    const autoFocus = (id === 0 && editing === null && autoFocusFirst) || id === editing
    pins.push(
      <PinCodeInputUnit
        key={id + value + reset} // force to re-render on update
        inputRef={ref => (pinInputRefs[id] = ref)}
        onChange={({target}) => handleEdit(target.value, id)}
        onFocus={() => setFocus(id)}
        value={value}
        maxLength={id === 0 ? length : 1}
        autoFocus={autoFocus}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        error={error}
        {...props}
      />,
    );
  }
  return (
    <div>
      <PinCodeContainer>{pins}</PinCodeContainer>
      <FormHelperText error={error}>{helperText}</FormHelperText>
    </div>
  );
};

PinCodeInput.propTypes = {
};

PinCodeInput.defaultProps = {
  length: 6,
  autoFocusFirst: true,
  obfuscation: false,
};

export default PinCodeInput
